import { ruleRunner } from 'validations/ruleRunner';
import { required, ruleIf } from 'validations/rules';

const MarketplaceValidation = [ruleRunner('marketplace_variation', 'variação do produto', ruleIf('marketplace', required))];

export default MarketplaceValidation;
